<template>
  <div class="can-toggle">
    <input
      :id="id"
      type="checkbox"
      v-model="enabled"
      @change="changeVal"
      :disabled="disable"
    />
    <label :for="id">
      <div
        class="can-toggle__switch"
        data-checked="On"
        data-unchecked="Off"
      ></div>
    </label>
  </div>
</template>

<script>
export default {
  props: {
    id: String,
    toggleState: Boolean,
    disable: {
      type: Boolean,
      default: false
    },
    canToggle: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return { enabled: this.toggleState };
  },
  methods: {
    changeVal() {
      this.$nextTick(() => {
        if (!this.canToggle) {
          this.enabled = true;
        }
      });
      this.$emit('toggleValue', this.enabled);
    }
  },
  watch: {
    toggleState: function(newVal) {
      // watch it
      this.enabled = newVal;
    }
  },
  mounted() {
    this.enabled = this.toggleState;
  }
};
</script>

<style>
.can-toggle,
.can-toggle label .can-toggle__switch {
  position: relative;
}

.can-toggle input[type='checkbox'] {
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
}
.can-toggle input[type='checkbox'][disabled] ~ label {
  pointer-events: none;
}
.can-toggle input[type='checkbox'][disabled] ~ label .can-toggle__switch {
  opacity: 0.4;
}
.can-toggle input[type='checkbox']:checked ~ label .can-toggle__switch:before {
  content: '' attr(data-checked) '';
  left: 0;
}
.can-toggle input[type='checkbox']:checked ~ label .can-toggle__switch:after {
  content: '';
  width: 20px;
  height: 20px;
}
.can-toggle label {
  user-select: none;
  position: relative;
  display: flex;
  align-items: center;
  width: 82px;
}

.can-toggle label .can-toggle__switch:before {
  content: attr(data-unchecked);
  position: absolute;
  top: 0;
  text-transform: uppercase;
  text-align: center;
}
.can-toggle label .can-toggle__switch:after {
  content: '';
  position: absolute;
  z-index: 5;
  text-transform: uppercase;
  text-align: center;
  background: #58e2c2;
  transform: translate3d(0, 0, 0);
}
.can-toggle input[type='checkbox'][disabled] ~ label {
  color: rgba(119, 119, 119, 0.5);
}
.can-toggle input[type='checkbox']:focus ~ label .can-toggle__switch,
.can-toggle input[type='checkbox']:hover ~ label .can-toggle__switch {
  background-color: #f4f4f5;
}

.can-toggle input[type='checkbox']:checked ~ label .can-toggle__switch {
  background-color: #f4f4f5;
}
.can-toggle input[type='checkbox']:checked ~ label .can-toggle__switch:after {
  color: #58e2c2;
}
.can-toggle input[type='checkbox']:checked:focus ~ label .can-toggle__switch,
.can-toggle input[type='checkbox']:checked:hover ~ label .can-toggle__switch {
  background-color: #f4f4f5;
}

.can-toggle label .can-toggle__switch {
  transition: background-color 0.3s cubic-bezier(0, 1, 0.5, 1);
  background: #f4f4f5;
}
.can-toggle label .can-toggle__switch:before {
  color: #58e2c2;
}
.can-toggle label .can-toggle__switch:after {
  -webkit-transition: -webkit-transform 0.3s cubic-bezier(0, 1, 0.5, 1);
  transition: transform 0.3s cubic-bezier(0, 1, 0.5, 1);
  color: #777;
}
.can-toggle input[type='checkbox']:focus ~ label .can-toggle__switch:after,
.can-toggle input[type='checkbox']:hover ~ label .can-toggle__switch:after,
.can-toggle
  input[type='checkbox']:checked:focus
  ~ label
  .can-toggle__switch:after,
.can-toggle
  input[type='checkbox']:checked:hover
  ~ label
  .can-toggle__switch:after {
  box-shadow: 0 3px 3px rgba(0, 0, 0, 0.1);
}
.can-toggle input[type='checkbox']:checked ~ label .can-toggle__switch:after {
  transform: translate3d(44px, 0, 0);
}

.can-toggle label .can-toggle__switch {
  height: 30px;
  flex: 0 0 82px;
}
.can-toggle label .can-toggle__switch:before {
  left: 35px;
  font-size: 14px;
  font-weight: 400;
  line-height: 30px;
  padding: 0 12px;
}
.can-toggle label .can-toggle__switch:after {
  top: 5px;
  left: 8px;
  width: 20px;
  height: 20px;
}
.can-toggle label .can-toggle__switch:hover:after {
  box-shadow: none;
}
</style>
